import React, { useEffect, useState, useMemo } from 'react';
import { useAccountStore } from 'src/hooks/admin/account';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Admin from "@system/config/admin";
import { AgGridReact } from 'ag-grid-react'; import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import { __remove, __set } from 'src/store/axios_indicator';
import Helper from 'src/helper/Helper';
import { useObjCommonFilterStore } from '../../../hooks/objCommonFilter';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const AccountList = () => {
  const [__check] = useAxiosIndicatorCheck();

  const [{ accountList, totalRecords }, {
    get_account_list,
    get_account_export, email_accouts }, { set_account_list }] = useAccountStore();

  const [rowData, setRowData] = useState([]);
  const gridRef = React.useRef();
  const [{ filter_list }, { }, { }] = useObjCommonFilterStore();
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

  const [agGridFiltered, setAgGridFiltered] = useState(0);
  const { downloadMsg } = Constants

  useEffect(() => {
    async function fetchHere() {
      await fetchAPICall()
    }

    fetchHere();

  }, [filter_list]);

  const loadAccountDetail = (e) => {
    const data = e?.data ? e?.data : e.node.allLeafChildren[0].data;
    return <>
      <a
        href={Admin.getAccountDetailURL() + '?accountNumber=' + data.AccountNumber + '&salesOrg=' + data.SalesOrg + '&speedboat=' + System.avUserInfoData.speedBoatAbbr}
        className='' target="_blank" rel="noreferrer"> {e?.value}</a>
    </>
  }

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      enableRowGroup: true,
      enableValue: true,
      // lockPinned: true,
      resizable: true
    };
  }, []);

  useEffect(() => {
    const _accountList = [];
    if (accountList?.length > 0) {
      accountList.map((_account) => {
        const _data = {
          AccountNumber: _account.accountNumber,
          AccountName: _account.accountName,
          SalesOrg: _account.salesOrg,
          Description: _account.description,
          Status: _account.status ? 'Active' : 'Inactive',
          CreatedOn: _account.createdOn ? Helper.getDatepickerFormatAdminConsole(_account.createdOn) : "",
          UpdatedOn: _account.updatedOn ? Helper.getDatepickerFormatAdminConsole(_account.updatedOn) : "",
          BillToCountry: _account.billToCountry,
          Currency: _account.currency,
          OrderBlock: _account.orderBlock ? 'Yes' : 'No',
          CreditRisk: _account.creditRisk ? 'Yes' : 'No',
          Payment: _account.payment,
        }
        _accountList.push(_data);
      })
    }
    setRowData(_accountList)
  }, [accountList]);

  const [columnDefs, setColumnDefs] = useState([
    {
      field: 'AccountNumber',
      headerName: 'ACCOUNT NUMBER',
      headerTooltip: 'ACCOUNT NUMBER',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      cellRenderer: loadAccountDetail,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'AccountName',
      headerName: 'ACCOUNT NAME',
      headerTooltip: 'ACCOUNT NAME',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'SalesOrg',
      headerName: 'SALES ORG',
      headerTooltip: 'SALES ORG',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'Description',
      headerName: 'DESCRIPTION',
      headerTooltip: 'DESCRIPTION',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'Status',
      headerName: 'STATUS',
      headerTooltip: 'STATUS',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'BillToCountry',
      headerName: 'BILL TO COUNTRY',
      headerTooltip: 'BILL TO COUNTRY',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'Currency',
      headerName: 'CURRENCY',
      headerTooltip: 'CURRENCY',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'CreatedOn',
      headerName: 'CREATED ON',
      headerTooltip: 'CREATED ON',
      sortable: true, comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }, minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'UpdatedOn',
      headerName: 'UPDATED ON',
      headerTooltip: 'UPDATED ON',
      sortable: true,
      comparator: Helper.dateSortingAgGrid,
      filter: 'agDateColumnFilter',
      filterParams: {
        suppressAndOrCondition: true,
        comparator: Helper.calendarAgGridComparator,
      }, minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'OrderBlock',
      headerName: 'ORDER BLOCK',
      headerTooltip: 'ORDER BLOCK',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
    {
      field: 'Payment',
      headerName: 'PAYMENT',
      headerTooltip: 'PAYMENT',
      sortable: true,
      comparator: Helper.textSortingAgGrid,
      minWidth: 150,
      unSortIcon: true
    },
  ]);

  const fetchAPICall = async () => {
    __set('USER_ACCOUNT_API_CALL')
    if (Object.entries(filter_list).length > 0) {
      const params = {
        accountName: filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : null,
        accountNumber: filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : null,
        salesOrg: filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr.map(item => item.value) : [],
        isActive: filter_list?.isAccountActive?.searchKeyword ? (filter_list?.isAccountActive?.searchKeyword === "Yes") : null,
        country: filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr.map(item => item.value) : [],
        createdDate: filter_list?.createdDate?.searchKeywordArr ? filter_list?.createdDate?.searchKeywordArr[0].value : null,
      }
      const data = await get_account_list(params)
      if (data?.payload?.Message) {
        system_alert_indicator({
            name: "accessDenied",
            message: data?.payload?.Message,
            type: "danger",
            isDisplayIcon: true,
            isDisplay: false
        });
    }
    } else {
      set_account_list()
    }
    __remove('USER_ACCOUNT_API_CALL')
  };
  const gridUpdateCallback = (event) => {
    setAgGridFiltered(event.api.getDisplayedRowCount());
  }

  const onGridReady = (params) => {
    setAgGridFiltered(params.api.getDisplayedRowCount());
    params.api.addEventListener('filterChanged', gridUpdateCallback)
    params.api.addEventListener('filterModified', gridUpdateCallback)
    setGridColumnApi(params.columnApi);
  }

  const exportGrid = async () => {
    $('#emailFilter').removeClass('open');
    __set('COMMON_API_CALL');
    if (agGridFiltered <= 2000) {
      // Fetch All Columns
      const allColumnState = gridColumnApi.getColumnState();
      // Filter Out Visible Columns
      const customColumns = allColumnState?.filter((column) => !column.hide && column.colId != '0')
        .map((column) => column.colId);

      const params = { fileName: `account_list.xlsx`, sheetName: "Account", columnKeys: customColumns };

      gridRef.current?.api.exportDataAsExcel(params);

      system_alert_indicator({
        name: "adminconsole",
        message: downloadMsg,
        type: "success",
        isDisplay: true,
      });
    } else {
      const params = {
        accountName: filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : null,
        accountNumber: filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : null,
        salesOrg: filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr.map(item => item.value) : [],
        isActive: filter_list?.isAccountActive?.searchKeyword ? (filter_list?.isAccountActive?.searchKeyword === "Yes") : null,
        country: filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr.map(item => item.value) : [],
        createdDate: filter_list?.createdDate?.searchKeywordArr ? filter_list?.createdDate?.searchKeywordArr[0].value : null,
        speedBoat: System.avUserInfoData.speedBoatAbbr
      }
      let res = await email_accouts(params);
      if (res.isSuccessFull) {
        system_alert_indicator({
          name: "adminconsole",
          message: "File will be sent as an email attachment due to large number of records",
          type: "success",
          isDisplay: true,
        });
      }
    }
    __remove('COMMON_API_CALL');
  }

  const onExportAll = async () => {
    $('#emailFilter').removeClass('open');
    __set('COMMON_API_CALL');
    if (totalRecords > 0 && totalRecords < 2000) {
      const data = await get_account_export({});
      Helper.downloadFileFromRes(data, 'account_list.xlsx');

      system_alert_indicator({
        name: "adminconsole",
        message: downloadMsg,
        type: "success",
        isDisplay: true,
      });
    } else {
      const params = {}
      let res = await email_accouts(params);
      if (res.isSuccessFull) {
        system_alert_indicator({
          name: "adminconsole",
          message: "File will be sent as an email attachment due to large number of records",
          type: "success",
          isDisplay: true,
        });
      }

    }
    __remove('COMMON_API_CALL');
  }
  return (
    <>
      {rowData.length > 0 &&
        <div className='w-100 d-flex align-items-center justify-content-between status-bar p-2'>
          <div className="d-flex justify-content-start">
            Filtered Line Count: <b>{agGridFiltered}</b>
          </div>
          <div className="d-flex justify-content-end">
            Total Records: <b>{totalRecords}</b>
          </div>
        </div>}
      <div className='bg-black p-2'>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center'></div>
          <div className='d-flex align-items-center'>
            <span id="emailFilter" className="dropdown me-2">
              <a href={void (0)} data-toggle="dropdown" aria-expanded="false" className='text-white'>
                <i className="fa fa-download me-1" aria-hidden="true"></i> Export List
              </a>
              <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton1">
                <li><a href={void (0)} onClick={onExportAll}>Export All</a></li>
                {rowData.length > 0 &&
                  <li><a href={void (0)} onClick={exportGrid}>Export Filtered</a></li>}
              </ul>
            </span>
          </div>
        </div>
      </div>
      {__check(['USER_ACCOUNT_API_CALL', 'COMMON_API_CALL']).render}
      {!__check(['USER_ACCOUNT_API_CALL', 'COMMON_API_CALL']).status &&
        <>
          {rowData?.length > 0 ?
            <div className="ag-theme-alpine ag-grd-hg mb-5">
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                suppressRowClickSelection={true}
                onGridReady={onGridReady}
                autoGroupColumnDef={{
                  headerName: 'Group',
                  minWidth: 220,
                }}
              >
              </AgGridReact>
            </div> :
            <>
              {Object.entries(filter_list).length > 0 ?
                <div className='container mt-5'>
                  <NoResultContent message={`Sorry! We can't find any results based on your selection.`}
                    isDisplay={false} />
                </div>
                : <div className='d-block pt-5 pb-5 mt-5 mb-5 minh150'></div>
              }
            </>
          }
        </>
      }
    </>

  );

}

export default AccountList;